import { cookieStorage, createStorage, http } from '@wagmi/core';

import { fallback } from 'viem';

import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { injected, walletConnect } from '@wagmi/connectors';

import { metadata, SUPPORTED_NETWORKS } from './configuration';

export const WALLET_CONNECT_PROJECT_ID =
  typeof process !== 'undefined' ? process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID ?? '' : '';

if (!WALLET_CONNECT_PROJECT_ID) {
  throw new Error('Wallet Connect Project ID is not defined');
}

const TRANSPORT_CONFIG = {
  timeout: 30_000,
  batch: {
    batchSize: 7,
    wait: 150,
  },
} as const;

export const wagmiAdapter = new WagmiAdapter({
  networks: SUPPORTED_NETWORKS.map(({ chain, overrides = {} }) => {
    const { name, rpcUrl } = overrides;

    return {
      ...chain,
      name: name ?? chain.name,
      ...(rpcUrl && {
        rpcUrls: {
          default: {
            http: [rpcUrl],
          },
        },
      }),
    };
  }),
  projectId: WALLET_CONNECT_PROJECT_ID,
  storage: createStorage({
    storage: cookieStorage,
  }),
  syncConnectedChain: false,
  multiInjectedProviderDiscovery: true,
  transports: Object.fromEntries(
    SUPPORTED_NETWORKS.map(({ chain, rpcUrls }) => [
      chain.id,
      fallback(rpcUrls.map((rpcUrl) => http(rpcUrl, TRANSPORT_CONFIG))),
    ]),
  ),
  connectors: [
    injected({ shimDisconnect: true }),
    walletConnect({
      projectId: WALLET_CONNECT_PROJECT_ID,
      metadata,
      qrModalOptions: {
        themeMode: 'dark',
      },
      showQrModal: false,
    }),
  ],
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

export type WagmiConfigChain = (typeof wagmiConfig)['chains'][number];

// TODO: we need to implement siwe using web3modal
// function createMessage({ nonce, address, chainId }: SIWECreateMessageArgs){
//   const message = new SiweMessage({
//     version: '1',
//     domain: window.location.host,
//     uri: window.location.origin,
//     address,
//     chainId,
//     nonce,
//     statement: 'Sign in With Ethereum.'
//   })

//   return message.prepareMessage()
// }

// const siweConfig = createSIWEConfig({
//   createMessage,
//   getNonce: () => getSIWENonce({}),
//   getSession: async () => {
//     const user = await getUserData();

//     // user.wallets[0].attributes.
//     return {
//       // address: user.wallets.

//     }
//   },
//   signOutOnDisconnect: true,
//   signOutOnAccountChange: true,
//   verifyMessage,
//   signOut
// })
